module.exports = __webpack_public_path__ + "media/images/default/shared/header/hamburger-cea9de22886e9716678c02d258e1781f.svg";